export default "__VITE_ASSET__cd60fd20__"